var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"side-clouds"},[_vm._l((15),function(a){return _c('div',{key:a,staticClass:"side-cloud"},_vm._l((5),function(b){return _c('div',{key:b,staticClass:"cloud"})}),0)}),_vm._v(" "),_c('div',{staticClass:"cloud-fill"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }